"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "art-lojban": 9117,
    "cel-gaulish": 9118,
    "en-gb-oed": 9119,
    "i-ami": 9120,
    "i-bnn": 9121,
    "i-default": 9122,
    "i-enochian": 9123,
    "i-hak": 9124,
    "i-klingon": 9125,
    "i-lux": 9126,
    "i-mingo": 9127,
    "i-navajo": 9128,
    "i-pwn": 9129,
    "i-tao": 9130,
    "i-tay": 9131,
    "i-tsu": 9132,
    "no-bok": 9133,
    "no-nyn": 9134,
    "sgn-be-fr": 9135,
    "sgn-be-nl": 9136,
    "sgn-ch-de": 9137,
    "zh-guoyu": 9138,
    "zh-hakka": 9139,
    "zh-min": 9140,
    "zh-min-nan": 9141,
    "zh-xiang": 9142
};
//# sourceMappingURL=grandfathered.json.js.map